import { useState, useEffect } from 'react';
import createAxiosInstance from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../utils/api";
import { User } from "../type/User";

const useUserData = () => {

  const axiosInstance = createAxiosInstance();

  const [userData, setUserData] = useState<User | null>(null);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const data = await axiosInstance.get<User>(API_ENDPOINTS.BEDFINDER.GETUSER);

        setUserData(data.data);
        // console.log('Fetched data:', data);  // Log the fetched data
      } catch (err) {
        console.log('Error fetching data:', err instanceof Error ? err.message : err);  // Log error
      }
    };

    getUserData();
  }, []);

  return userData;
};

export default useUserData;
